import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card } from "../components/ui/card";
import { Zap, Mail, ArrowLeft, Check } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const nav = useNavigate();

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Falls die Email existiert, wurde ein Reset-Link versendet.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Fehler");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background bg-grain p-6">
      <Card className="w-full max-w-md p-8 rounded-3xl border-border/60 glass">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-xl bg-primary/15 text-primary flex items-center justify-center"><Zap className="w-5 h-5" /></div>
          <div className="font-heading text-xl font-bold">Navero</div>
        </div>
        {sent ? (
          <div className="text-center py-4" data-testid="forgot-sent">
            <div className="w-16 h-16 mx-auto rounded-3xl bg-accent/15 text-accent flex items-center justify-center mb-4">
              <Check className="w-8 h-8" />
            </div>
            <h2 className="font-heading text-2xl font-bold mb-2">Email gesendet</h2>
            <p className="text-sm text-muted-foreground mb-6">
              Wir haben einen Link an <b className="text-foreground">{email}</b> gesendet.<br />
              Der Link ist 60 Minuten gültig. Bitte prüfe auch deinen Spam-Ordner.
            </p>
            <Button onClick={() => nav("/login")} className="rounded-full w-full" data-testid="back-to-login">
              <ArrowLeft className="w-4 h-4 mr-2" /> Zurück zum Login
            </Button>
          </div>
        ) : (
          <>
            <h2 className="font-heading text-2xl font-bold mb-2">Passwort vergessen?</h2>
            <p className="text-sm text-muted-foreground mb-6">Kein Problem. Gib deine Email ein und wir senden dir einen Link zum Zurücksetzen.</p>
            <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
              <div>
                <Label>Email</Label>
                <div className="relative mt-1">
                  <Mail className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground" />
                  <Input type="email" value={email} onChange={e => setEmail(e.target.value)} required
                         className="rounded-full h-11 pl-10 pr-5" data-testid="forgot-email" />
                </div>
              </div>
              <Button type="submit" disabled={loading} className="w-full rounded-full h-11 font-semibold" data-testid="forgot-submit">
                {loading ? "Wird gesendet..." : "Link senden"}
              </Button>
            </form>
            <div className="mt-5 text-center text-sm text-muted-foreground">
              <Link to="/login" className="text-primary font-semibold hover:underline" data-testid="link-back-login">
                <ArrowLeft className="w-3 h-3 inline mr-1" /> Zurück zum Login
              </Link>
            </div>
          </>
        )}
      </Card>
    </div>
  );
}
